module.exports = __webpack_public_path__ + "static/img/login-file2.bd12692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-file2.png
// module id = kPiN
// module chunks = 1